import { fetchWrapper } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/dashboard';

  static async findAll(filters) {
    return await fetchWrapper.get(this.baseUrl);
  }
}

export class coordinator {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/coordinator/dashboard';

  static async findAll(filters) {
    return await fetchWrapper.get(this.baseUrl);
  }
}

export class supervisor {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/dashboard';

  static async findAll(filters) {
    const url = `${this.baseUrl}/supervisor/web`;
    return await fetchWrapper.get(url);
  }
}
